import topApi from '../../../components/api/ToPApi';

// Propinas y cargo por servicio (reglas en el API: services/tips.ts)

export type Distribution = 'MESERO' | 'FONDO';

export interface TipSettings {
    enabled: boolean;
    percentages: number[];
    allowCustom: boolean;
    allowFixed: boolean;
    chargeId: number | null;
    distribution: Distribution;
}

export interface ChargeOption {
    id: number;
    description: string;
    appliesToAllInvoice: boolean;
}

export interface TipRow {
    waiterId: number | null;
    waiter: string;
    invoices: number;
    sales: number;
    tips: number;
    service: number;
    payout: number;
}

export interface TipReport {
    from: string;
    to: string;
    distribution: Distribution;
    rows: TipRow[];
}

export const DISTRIBUTION_LABELS: Record<Distribution, { title: string; description: string }> = {
    MESERO: { title: 'Por mesero', description: 'Cada mesero recibe las propinas y el servicio de sus órdenes.' },
    FONDO: { title: 'Fondo común', description: 'Todo se suma y se reparte por igual entre los meseros del periodo.' },
};

const errorMessage = (e: any) => e?.response?.data?.error || 'Ocurrió un error de comunicación, intente de nuevo.';

export const loadTipSettings = async () => {
    try {
        const resp = await topApi.get<{ settings: TipSettings; configured?: boolean; charges: ChargeOption[]; serviceCharge: boolean }>('/tips/settings');
        return resp.data;
    } catch (e) {
        throw new Error(errorMessage(e));
    }
};

export const saveTipSettings = async (settings: TipSettings, serviceCharge: boolean) => {
    try {
        const resp = await topApi.put<{ settings: TipSettings; charges: ChargeOption[] }>('/tips/settings', { settings: { ...settings, serviceCharge } });
        return resp.data;
    } catch (e) {
        throw new Error(errorMessage(e));
    }
};

export const loadTipReport = async (from: string, to: string): Promise<TipReport> => {
    try {
        const resp = await topApi.get<TipReport>('/tips/report', { params: { from, to } });
        return resp.data;
    } catch (e) {
        throw new Error(errorMessage(e));
    }
};

// "5, 10,15" → [5, 10, 15]
export const parsePercentagesText = (text: string) =>
    [...new Set(text.split(',').map(v => Number(v.trim())).filter(v => Number.isFinite(v) && v > 0 && v <= 100))]
        .sort((a, b) => a - b);

export const reportTotals = (rows: TipRow[]) => rows.reduce(
    (t, r) => ({ invoices: t.invoices + r.invoices, sales: t.sales + r.sales, tips: t.tips + r.tips, service: t.service + r.service, payout: t.payout + r.payout }),
    { invoices: 0, sales: 0, tips: 0, service: 0, payout: 0 },
);

// Filas para exportar a CSV
export const reportCsvRows = (report: TipReport) => report.rows.map(r => ({
    Mesero: r.waiter,
    Facturas: r.invoices,
    'Total facturado': r.sales.toFixed(2),
    Propinas: r.tips.toFixed(2),
    'Servicio y otros cargos': r.service.toFixed(2),
    [`Le corresponde (${DISTRIBUTION_LABELS[report.distribution].title.toLowerCase()})`]: r.payout.toFixed(2),
}));
